import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const FAQS = [
  { q: "Çekim ücretine neler dahil?", a: "Seçtiğiniz pakete göre fotoğraf, video, retouch, dijital teslim ve albüm dahildir. Paket içerikleri sayfada açıkça listelenmiştir; net teklif için bize ulaşabilirsiniz." },
  { q: "Ankara'nın hangi ilçelerinde çekim yapıyorsunuz?", a: "Ankara'nın 25 ilçesinin tamamında; Çankaya, Keçiören, Yenimahalle, Gölbaşı, Beypazarı, Kızılcahamam ve diğer tüm ilçelerde dış çekim yapıyoruz." },
  { q: "Fotoğraflar ne zaman teslim ediliyor?", a: "Düzenlenmiş tüm fotoğraflarınızı çekimden sonra 7 gün içinde online galeri linki ile dijital olarak teslim ediyoruz." },
  { q: "Poz vermeyi bilmiyoruz, sorun olur mu?", a: "Hiç sorun değil. Kamera karşısında profesyonel olmanız gerekmez; doğru yönlendirmeyle en doğal haliniz en güzel kareye dönüşür." },
  { q: "Rezervasyon için ne zaman iletiflime geçmelim?", a: "Özellikle bahar ve sonbahar yoğun dönemlerdir. Sevdiğiniz tarihi kaçırmamak için 2-4 ay önceden iletişime geçmenizi öneririz." },
  { q: "Hava yağışlı olursa ne oluyor?", a: "Alternatif kapalı/tarihi mekân planları ve yedek tarih seçenekleriyle çekiminizi güvence altına alıyoruz. Detayları rezervasyon sırasında netleştiriyoruz." },
];

export const Faq = () => (
  <section className="section-pad bg-[#0E0F10]">
    <div className="container-lux max-w-3xl">
      <Reveal>
        <div className="text-center">
          <span className="eyebrow justify-center">Sık Sorulan Sorular</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#F7F2E8] mt-3">
            Merak ettikleriniz
          </h2>
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-white/10">
              <AccordionTrigger className="text-left text-[#EDE7DA] hover:text-white text-base py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#9A9387] leading-relaxed text-[15px]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
